import boxShadows from "../../base/boxShadows";
import typography from "../../base/typography";
import colors from "../../base/colors";
import borders from "../../base/borders";

import pxToRem from "../../functions/pxToRem";

const { size } = typography;
const { text, background, divider } = colors;
const { borderRadius } = borders;

const menu = {
  defaultProps: {
    disableAutoFocusItem: true,
  },

  styleOverrides: {
    paper: {
      minWidth: pxToRem(160),
      boxShadow: boxShadows.lg,
      padding: pxToRem(4),
      fontSize: size.sm,
      color: text.main,
      textAlign: "left" as const,
      backgroundColor: `${background.paper} !important`,
      border: `1px solid ${divider}`,
      borderRadius: borderRadius.lg,

      "& .MuiMenuItem-root": {
        minWidth: pxToRem(160),
      },
    },
  },
};

export default menu;
